"use strict";

class CustomerToolAdvancedSearchController {

  constructor($scope, SSHttpService, SSAlertService, SSConfigService, $timeout, SSAppService, SSUserService) {
    const self = this;

    self.SSHttpService = SSHttpService;
    self.SSAlertService = SSAlertService;
    self.SSConfigService = SSConfigService;
    self.SSAppService = SSAppService;
    self.SSUserService = SSUserService;

    self.$timeout = $timeout;

    self.init();
  }

  init() {
    const self = this;
    self.advancedSearchSelectedTab = 1;
    self.limit = 15;
    self.offset = 0;
    self.regions_check_all = false;

    self.levels = {
        'PRIMARY': true,
        'SECONDARY': true,
        'JUNIOR COLLEGE': true,
        'UNIVERSITY': true,
        'INTERNATIONAL': true,
        'MIXED LEVEL': true,
        'ART INSTITUTE': true
    };
 
    self.retrieveSearchData();
    self.search_schools = [];
    self.search_developers = [];

    self.show_mrt_list = true;
    self.show_lrt_list = true;
    self.show_ew = true;
    self.show_ns = true;
    self.show_cg = true;
    self.show_ne = true;
    self.show_cc = true;
    self.show_ce = true;
    self.show_dt = true;
    self.show_tel = true;
    self.show_te = true;
    self.show_jr = true;
    self.show_bp = true;
    self.show_stc = true;
    self.show_ptc = true;

    self.initSearch();
  }

  retrieveSearchData() {
    const self = this;

    let url = "advance-search-data";

    self.SSHttpService.getAPIRequest(url).then(function (response) {
        if (response instanceof Error) {
            self.SSAlertService.parseAndDisplayError(response);
            return;
        }

        self.raw_schools = response.data.schools;
        self.raw_mrt_stations = response.data.mrt_stations;
        self.raw_developers = response.data.developers;

        self.prepareSchools();
        self.prepareDevelopers();
        self.prepareMrts();
    });

    self.regions = self.SSConfigService.getRegions(702);
  }

  prepareMrts() {
    const self = this;

    let temp_mrts = self.processMrtArray(self.raw_mrt_stations);

    //Reorder developers
    self.mrt_stations = [];

    for (var o in temp_mrts) {
        let obj = {
            line: o,
            line_name: temp_mrts[o][0].line_name,
            type: temp_mrts[o][0].type,
            show: true,
            list: temp_mrts[o]
        };
        self.mrt_stations.push(obj)
    }

    self.filtered_mrt_stations = angular.copy(self.mrt_stations);
  }

  processMrtArray(raw_mrt_stations) {
    let processed_mrt_stations = raw_mrt_stations.reduce((a,c) => {
      let k = c['line_code'];
      if (a[k]) 
        a[k].push(c);
      else 
        a[k] = [c];

      return a;
    }, {});

    return processed_mrt_stations;
  }

  prepareDevelopers() {
    const self = this;

    let temp_developers = self.processArray(self.raw_developers);

    //Reorder developers
    self.developers = [];

    for (var o in temp_developers) {
        let obj = {
            alphabet: o,
            list: temp_developers[o]
        };
        self.developers.push(obj)
    }

    self.developers.sort(function(a,b){
        return a.alphabet.localeCompare(b.alphabet);
    });

    self.selected_developer_list = self.developers[0];
  }

  prepareSchools() {
    const self = this;

    let temp_schools = self.processArray(self.raw_schools);

    //Reorder schools
    self.schools = [];

    for (var o in temp_schools) {
        let obj = {
            alphabet: o,
            filtered_list: angular.copy(temp_schools[o]),
            raw_list: temp_schools[o]
        };
        self.schools.push(obj)
    }

    self.schools.sort(function(a,b){
        return a.alphabet.localeCompare(b.alphabet);
    });

    self.selected_school_list = self.schools[0];    //Default to get the first school as selected school list

  }

  processArray(raw_array) {
    let processed_array = raw_array.reduce((a, c) => {
        // c[0] should be the first letter of an entry
        let k = c['name'][0].toLocaleUpperCase();

        // either push to an existing dict entry or create one
        if (a[k]) 
          a[k].push(c);
        else 
          a[k] = [c];

        return a;
    }, {});

    return processed_array;
  }

  updateSearchSchoolsLevel() {
    const self = this;

    //Setup levels list
    let filtered_levels = [];

    $.each(self.levels, function(index, level) {
        if (level) {
            filtered_levels.push(index);
        }
    });

    self.selected_school_list.filtered_list = self.selected_school_list.raw_list.filter(x => filtered_levels.includes(x.level.trim()));
  }

  updateSearchSchoolsList(school) {
    const self = this;

    self.selected_school_list = school;

    self.updateSearchSchoolsLevel();
  }

  updateOtherKeywords(keyword_type, keyword_obj) {
    const self = this;

    if (self.other_keywords == undefined || !self.other_keywords) {
      self.other_keywords = [];
    }

    if (keyword_obj) {
      self.removeOtherKeywords(keyword_type);
      let temp_name = "";

      if (keyword_type == self.min_price_keyword) {
        temp_name = "Min: " + keyword_obj.name;
      } else if (keyword_type == self.max_price_keyword) {
        temp_name = "Max: " + keyword_obj.name;
      } else {
        temp_name = keyword_obj.name;
      }
      
      self.other_keywords.push({
        type: keyword_type,
        value: keyword_obj.id,
        name: temp_name,
      });
    } else {
      self.removeOtherKeywords(keyword_type);
    }
  }

  removeOtherKeywords(keyword_type) {
    const self = this;

    self.other_keywords = $.grep(self.other_keywords, function(e){ 
      return e.type != keyword_type; 
    });
  }

  initSearch() {
    const self = this;
    
    self.other_keywords = [];
    self.properties = [];
    self.searched = false;
    self.searched_value = "";

    self.unit_type_keyword = "unit_type";
    self.psf_keyword = "psf";
    self.min_price_keyword = "min_price";
    self.max_price_keyword = "max_price";
    self.property_type_keyword = "property_type";
    self.tenure_keyword = "tenure";
    self.from_completion_date_keyword = "from_completion_date";
    self.to_completion_date_keyword = "to_completion_date";

    self.psfs = [
      {
        id: 500,
        name: '$500 PSF'
      },
      {
        id: 600,
        name: '$600 PSF'
      },
      {
        id: 700,
        name: '$700 PSF'
      },
      {
        id: 800,
        name: '$800 PSF'
      },
      {
        id: 900,
        name: '$900 PSF'
      },
      {
        id: 1000,
        name: '$1000 PSF'
      },
      {
        id: 1100,
        name: '$1,100 PSF'
      },
      {
        id: 1200,
        name: '$1,200 PSF'
      },
      {
        id: 1300,
        name: '$1,300 PSF'
      },
      {
        id: 1400,
        name: '$1,400 PSF'
      },
      {
        id: 1500,
        name: '$1,500 PSF'
      },
      {
        id: 1600,
        name: '$1,600 PSF'
      },
      {
        id: 1700,
        name: '$1,700 PSF'
      },
      {
        id: 1800,
        name: '$1,800 PSF'
      },
      {
        id: 1900,
        name: '$1,900 PSF'
      },
      {
        id: 2000,
        name: '$2,000 PSF'
      },
      {
        id: 2100,
        name: '$2,100 PSF'
      },
      {
        id: 2200,
        name: '$2,200 PSF'
      },
      {
        id: 2300,
        name: '$2,300 PSF'
      },
      {
        id: 2400,
        name: '$2,400 PSF'
      },
      {
        id: 2500,
        name: '$2,500 PSF'
      },
      {
        id: 2600,
        name: '$2,600 PSF'
      },
      {
        id: 2700,
        name: '$2,700 PSF'
      },
      {
        id: 2800,
        name: '$2,800 PSF'
      },
      {
        id: 2900,
        name: '$2,900 PSF'
      },
      {
        id: 3000,
        name: '$3,000 PSF'
      }
    ];

    self.prices = [
      {
        id: 200000,
        name: '$200,000'
      },
      {
        id: 300000,
        name: '$300,000'
      },
      {
        id: 400000,
        name: '$400,000'
      },
      {
        id: 500000,
        name: '$500,000'
      },
      {
        id: 600000,
        name: '$600,000'
      },
      {
        id: 700000,
        name: '$700,000'
      },
      {
        id: 800000,
        name: '$800,000'
      },
      {
        id: 900000,
        name: '$900,000'
      },
      {
        id: 1000000,
        name: '$1,000,000'
      },
      {
        id: 1200000,
        name: '$1,200,000'
      },
      {
        id: 1500000,
        name: '$1,500,000'
      },
      {
        id: 1800000,
        name: '$1,800,000'
      },
      {
        id: 2000000,
        name: '$2,000,000'
      },
      {
        id: 3000000,
        name: '$3,000,000'
      },
      {
        id: 4000000,
        name: '$4,000,000'
      },
      {
        id: 5000000,
        name: '$5,000,000'
      },
      {
        id: 6000000,
        name: '$6,000,000'
      },
      {
        id: 7000000,
        name: '$7,000,000'
      },
      {
        id: 8000000,
        name: '$8,000,000'
      },
      {
        id: 9000000,
        name: '$9,000,000'
      },
      {
        id: 10000000,
        name: '$10,000,000'
      },
      {
        id: 11000000,
        name: '$11,000,000'
      },
      {
        id: 12000000,
        name: '$12,000,000'
      },
      {
        id: 13000000,
        name: '$13,000,000'
      },
      {
        id: 14000000,
        name: '$14,000,000'
      },
      {
        id: 15000000,
        name: '$15,000,000'
      },
      {
        id: 16000000,
        name: '$16,000,000'
      },
      {
        id: 17000000,
        name: '$17,000,000'
      },
      {
        id: 18000000,
        name: '$18,000,000'
      },
      {
        id: 19000000,
        name: '$19,000,000'
      },
      {
        id: 20000000,
        name: '$20,000,000'
      },
      {
        id: 21000000,
        name: '$20,000,000 & Above'
      }
    ];

    self.tenures = [
      {
        id: 99,
        name: '99 Years'
      },
      {
        id: 103,
        name: '103 Years'
      },
      {
        id: 999,
        name: '999 Years'
      },
      {
        id: 'Freehold',
        name: 'Freehold'
      }
    ];

    self.$timeout(function() { 
        $("select.search-select").niceSelect('update');
    });
  }

  updateShowMrtLrtList() {
    const self = this;

    let temp_mrt_stations = angular.copy(self.mrt_stations);
    let temp_lrt_stations = angular.copy(self.mrt_stations);

    temp_mrt_stations = temp_mrt_stations.filter(x => x.type === 2);
    temp_lrt_stations = temp_lrt_stations.filter(x => x.type === 1);

    self.filtered_mrt_stations = [];
    if (self.show_mrt_list) {
      self.filtered_mrt_stations = $.merge(self.filtered_mrt_stations, temp_mrt_stations);
    }

    if (self.show_lrt_list) {
      self.filtered_mrt_stations = $.merge(self.filtered_mrt_stations, temp_lrt_stations);
    }

    self.updateShowMrtLrt();
  }

  updateShowMrtLrt() {
    const self = this;

    self.filtered_mrt_stations.find(x => x.line == 'EW').show = self.show_ew;
    self.filtered_mrt_stations.find(x => x.line == 'NS').show = self.show_ns;
    self.filtered_mrt_stations.find(x => x.line == 'CG').show = self.show_cg;
    self.filtered_mrt_stations.find(x => x.line == 'NE').show = self.show_ne;
    self.filtered_mrt_stations.find(x => x.line == 'CC').show = self.show_cc;
    self.filtered_mrt_stations.find(x => x.line == 'CE').show = self.show_ce;
    self.filtered_mrt_stations.find(x => x.line == 'DT').show = self.show_dt;
    self.filtered_mrt_stations.find(x => x.line == 'TE').show = self.show_te;
    self.filtered_mrt_stations.find(x => x.line == 'JR').show = self.show_jr;
    self.filtered_mrt_stations.find(x => x.line == 'BP').show = self.show_bp;
    self.filtered_mrt_stations.find(x => x.line == 'STC').show = self.show_stc;
    self.filtered_mrt_stations.find(x => x.line == 'PTC').show = self.show_ptc;
  }

  homePageSearch(type) {
    const self = this;

    let params = {
      sq_type: 1,
      keyword: self.searched_value,
      send_total_count: true,
      offset: 0,
      limit: self.limit
    };

    $.each(self.other_keywords, function(index, keyword) {
      switch (keyword.type) {
        case self.unit_type_keyword:
          params["unit_type"] = keyword.value;
          break;
        case self.psf_keyword:
          params["min_psf"] = keyword.value;
          break;
        case self.min_price_keyword:
          params["min_price"] = keyword.value;
          break;
        case self.max_price_keyword:
          params["max_price"] = keyword.value;
          break;
        case self.property_type_keyword:
          params["property_type"] = keyword.value;
          break;
        case self.tenure_keyword:
          params["tenure"] = keyword.value;
          break;
        // case self.from_completion_date_keyword:
        //   params["unit_type"] = keyword.value;
        //   break;
        // case self.to_completion_date_keyword:
        //   params["unit_type"] = keyword.value;
        //   break;
        default:
          console.log("shouldn't happen!!");
          return;
          break;
      }
    });

    switch (type) {
      case 'region':
        let search_region = [];
        if (self.regions_check_all) {
          search_region = $.merge(search_region, self.regions);
        } else {
          $.each(self.regions, function(counter, region) {
            if (region.check) {
              search_region.push(region);
            }
          });
        }

        if (search_region.length > 0) {
          params['districts'] = search_region.map(x => x.code).join(",");
        }
        break;

      case 'mrt':
        let search_mrt = [];
        $.each(self.filtered_mrt_stations, function(index, mrt_stations) {
          if (mrt_stations.check_all) {
            search_mrt = $.merge(search_mrt, mrt_stations.list);
          } else {
            $.each(mrt_stations.list, function(counter, mrt_station) {
              if (mrt_station.check) {
                search_mrt.push(mrt_station);
              }
            });
          }
        });

        if (search_mrt.length > 0) {
          params['mrt_stations'] = search_mrt.map(x => x.id).join(",");
        }
        break;

      case 'school':
        let search_school = [];
        if (self.selected_school_list.check_all) {
          search_school = $.merge(search_school, self.selected_school_list.filtered_list);
        } else {
          $.each(self.selected_school_list.filtered_list, function(counter, school) {
            if (school.check) {
              search_school.push(school);
            }
          });
        }

        if (search_school.length > 0) {
          params['schools'] = search_school.map(x => x.id).join(",");
        }
        break;

      case 'developer':
        let search_developer = [];
        if (self.selected_developer_list.check_all) {
          search_developer = $.merge(search_developer, self.selected_developer_list.list);
        } else {
          $.each(self.selected_developer_list.list, function(counter, developer) {
            if (developer.check) {
              search_developer.push(developer);
            }
          });
        }

        if (search_developer.length > 0) {
          params['developers'] = search_developer.map(x => x.id).join(",");
        }
        break;


      default:
        break;
    }

    loading(true);
    self.SSHttpService.getAPIRequest('search', params).then(function (response) {
      loading(false);
      if (response instanceof Error) {
        self.SSUtilService.logError(response);
        return;
      }

      self.properties = response.data.properties;
      self.total_property_view_count = response.data.total;
      self.searched_value = "";
      self.searched = true;
      self.updatePropertiesSoldOut();
    });   
  }

  updatePropertiesSoldOut() {
    const self = this;

    if (self.properties) {
      $.each(self.properties, function(index, property) {
        property.available_balance = self.SSAppService.getRemainingUnits(property);
      });
    }
  }

  getPropertyHeroImageUrl(property_assets){
    const self = this;

    if(!property_assets){
      return;
    }

    let asset = property_assets.find(x => x.type == SHOWSUITE.PROPERTY_ASSET_TYPE_HERO_IMAGE);

    if(!asset){
      return;
    }

    return self.SSAppService.getAssetUrl(asset.file_uri);
  }

  getPropertyLogoImageUrl(property_assets){
    const self = this;

    if(!property_assets){
      return '/images/placeholder.jpg';
    }

    let asset = property_assets.find(x => x.type == SHOWSUITE.PROPERTY_ASSET_TYPE_LOGO_IMAGE);

    if(!asset){
      return '/images/placeholder.jpg';
    }
    
    return self.SSAppService.getAssetUrl(asset.file_uri);
  }

  resetSearchData(type) {
    const self = this;

    self.properties = [];
    self.searched = false;
    self.other_keywords = [];

    switch (type) {
      case 'region':
        self.regions_check_all = false;
        self.updateAllRegionCheckbox();
        break;

      case 'mrt':
        $.each(self.filtered_mrt_stations, function(index, mrt_stations) {
          mrt_stations.check_all = false;
          self.updateAllStationCheckbox(mrt_stations);
        });
        break;

      case 'school':
        self.selected_school_list.check_all = false;
        self.updateAllSchoolCheckbox(self.selected_school_list);
        break;

      case 'developer':
        self.selected_developer_list.check_all = false;
        self.updateAllDeveloperCheckbox(self.selected_developer_list);
        break;


      default:
        break;
    }
  }

  updateAllStationCheckbox(mrt_stations) {
    $.each(mrt_stations.list, function(index, mrt_station) {
      mrt_station.check = mrt_stations.check_all;
    })
  }

  updateStationCheckbox(mrt_stations, mrt_station) {
    if (!mrt_station.check) {
      mrt_stations.check_all = false;
    }
  }

  updateAllSchoolCheckbox(schools) {
    $.each(schools.filtered_list, function(index, school) {
      school.check = schools.check_all;
    })
  }

  updateSchoolCheckbox(schools, school) {
    if (!school.check) {
      schools.check_all = false;
    }
  }

  updateAllDeveloperCheckbox(developers) {
    $.each(developers.list, function(index, developer) {
      developer.check = developers.check_all;
    })
  }

  updateDeveloperCheckbox(developers, developer) {
    if (!developer.check) {
      developers.check_all = false;
    }
  }

  viewMore() {
    const self = this;

    self.offset += self.limit;

    let params = {
      'offset': self.offset,
      'limit': self.limit,
      'send_total_count': true
    };

    loading(true);
    self.SSHttpService.getAPIRequest('properties', params).then(function (responseObj) {
      loading(false);
      if (responseObj instanceof Error) {
        self.SSAlertService.parseAndDisplayError(response);
        return;
      }

      self.properties = self.properties.concat(responseObj.data.properties);
      SHOWSUITE.data.properties = self.properties;
    });
  }

  updateAllRegionCheckbox() {
    const self = this;

    $.each(self.regions, function(index, region) {
      region.check = self.regions_check_all;
    })
  }

  updateRegionCheckbox(region) {
    const self = this;

    if (!region.check) {
      self.regions_check_all = false;
    }
  }
}

CustomerToolAdvancedSearchController.$inject = ['$scope', 'SSHttpService', 'SSAlertService', 'SSConfigService', '$timeout', 'SSAppService', 'SSUserService'];
app.controller('CustomerToolAdvancedSearchController', CustomerToolAdvancedSearchController);
